import { styled, Checkbox } from "@mui/material";
export const MyCheckbox = styled(Checkbox)(({ theme }) => ({
  padding: 0,
  color: "#C8C8C8"
}));

